module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"optional":"Optional","charactersLeft":"characters left"}}')
  delete Component.options._Ctor
}
